import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "../../../context/authProvider";
import { auth } from "../../../firebase";
import GMTLoading from "../../core/gmtLoading";

export default function EmailVerified() {

    const { user, setUserEmailVerified } = useAuth();
    const [checking, setChecking] = useState(true);
    const [verified, setVerified] = useState(false);

    useEffect(() => {
        const checkVerification = async () => {
            try {
                // força o SDK a buscar o estado atualizado do servidor — sem isso,
                // auth.currentUser.emailVerified pode ainda refletir o valor em cache
                // de antes do usuário clicar no link de verificação recebido por email.
                await auth.currentUser?.reload();
            } catch (error) {
                console.log(error);
            }
            const isVerified = !!auth.currentUser?.emailVerified;
            setVerified(isVerified);
            if (isVerified) {
                setUserEmailVerified();
            }
            setChecking(false);
        }
        checkVerification();
        // eslint-disable-next-line
    }, []);

    if (checking) {
        return <GMTLoading />
    }

    return (
        user && verified ?
            <main className="min-h-screen bg-primary py-10">
                <p className="text-center text-lg text-green-500">Seu email foi verificado com sucesso!</p>
                <Link className="text-center underline w-fit m-auto block text-secondary" to={"/me"}>voltar</Link>
            </main>
            :
            <Navigate to="/me" />
    )
}
